import React, { useState, useEffect } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const EditRateDrawer = ({ isOpen, onClose, rate, onUpdateRate }) => {
  const [formData, setFormData] = useState({
    rate_per_km: 0,
  });

  useEffect(() => {
    if (rate) {
      setFormData({ rate_per_km: rate.rate_per_km || 0 });
    }
  }, [rate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ [name]: parseFloat(value) });
  };

  const handleSubmit = () => {
    onUpdateRate({ ...rate, ...formData });
    onClose();
  };

  if (!rate) return null;

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Edit Kilometer Rate</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Rate per KM"
            name="rate_per_km"
            value={formData.rate_per_km}
            onChange={handleChange}
            placeholder="Rate per kilometer"
            type="number"
            step="0.01"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} width="100px" height="40px">
            Cancel
          </GradientButton>
          <GradientButton onClick={handleSubmit} width="100px" height="40px">
            Update
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditRateDrawer;
